<template>
  <div class="content2">
    <vue-headful
    title="Dashboard | Bookmarked Logos"
    description="Dashboard | Bookmarked Logos"
/>

<div v-if="propsdata[0].loading_logos" style="margin: 0 auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


    <div v-if="!propsdata[0].loading_logos" class="sc-bvTASY jPMoWD">

             <div v-if="propsdata[0].logos !== null" class="sc-cFlXAS WflZx">
               <div class="row">
                <div class="col-md-12 col-lg-6-franco mb-4" v-for="(logos, num) in propsdata[0].logos" :key="logos.unique_id">
                  <div class="pricing-card">
                  <div class="card shadow-soft border-light">
                  <div class="row no-gutters align-items-center">
                   <div class="col-sm-7">
                     <header class="card-header text-center">
                       <span class="d-block">
                         <div @click="logo_number(num)" data-toggle="modal" data-target="#modal-default" class="sc-cmIlrE haTfuX dashboard-display-logo drag_disabled" :style="'height: fit-content;width: -webkit-fill-available;background:'+logos.background+';'">
                          <div v-if="propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes'">
                            <div v-if="logos.svglogos_s3 === 'needs_update'">
                              <img :src="'https://logo.app/svglogos/'+logos.unique_id+'.svg?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || logos.one_time_payment === 'yes'">
                            <div v-if="logos.paid_svglogos_s3 === 'needs_update'">
                              <img :src="'https://logo.app/paid-svglogos/'+logos.unique_id+'.svg?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logos.unique_id+'.svg?'+timenow" />
                            </div>
                          </div>
                         </div>
                       </span>
                       </header>
                   </div>
                   <div class="col-sm-5 elpaddingdelmobileversion" style="padding-top: 1.5rem;padding-bottom: 1.5rem;">
                     <div class="sc-dBaXSw hCpORs">
                        <div class="sc-ccLTTT fBHvCq">
                           <div class="sc-hlILIN cLFOMf">
                              <div class="sc-jQMNup eRizKN">
                                <a @click="lapicito(num)" v-if="numeroedit !== num" class="sc-bJHhxl kkRCtf">{{logos.titulo}}</a>
                               <div v-if="edit && numeroedit === num" v-click-outside="hide">
                                <input v-model="logos.titulo" @keyup='edittitulo(num)' @keyup.enter='hide' type="text" placeholder="Untitled" style="background: transparent;border: transparent;outline: none;border-bottom: 2px solid #0949b3;color:#515151;width: 169px;padding: 0;font-weight: 300;" autofocus="autofocus" onfocus="this.select()">
                               </div>
                                <div @click="lapicito(num)" v-if="numeroedit !== num" class="sc-gAmQfK gQXEKA">
                                   <div class="sc-hwwEjo leOORe">
                                      <div class="sc-hAXbOi jxPiur simptip-position-top simptip-smooth" data-tooltip="Rename">
                                         <svg width="24" height="24" style="margin-bottom: 10px;" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"></path>
                                         </svg>
                                      </div>
                                   </div>
                                </div>
                              </div>
                              <div in="exited" class="sc-dphlzf hsJJHO"></div>
                           </div>
                        </div>
                        <div class="sc-bNQFlB jaiNr">
                           <div class="sc-hizQCF dXstwa">Created {{logos.datetime}}</div>
                        </div>
                        <div class="border-light border-bottom pb-1 mb-3">
                        <div style="display:flex; margin-bottom:12px;">
                          <a :href="'/create/edit-logo/'+logos.unique_id+'?ref=edit'">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Edit</div>
                           </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a class="preview_btnhover" @click="logo_number(num)" data-toggle="modal" data-target="#modal-default">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="22" height="22" fill="#0949b3" style="margin-right: 2px;">
                               <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                             </svg>
                           </div>
                           <div style="display: inline;">Preview</div>
                         </a>
                        </div>
                        <div style="display: flex; margin-bottom: 12px;">
                          <a @click="show_duplicate_modal(num)" class="preview_btnhover">
                            <i class="fa-solid fa-copy" style="color:#0a49b3;margin-right: 5px;margin-left: 3px;"></i>
                            <div style="display: inline;">Duplicate</div>
                          </a>
                        </div>
                        <div style="display: flex; margin-bottom: 12px;">
                          <router-link :to="'/dashboard/logo-files/'+logos.unique_id" class="preview_btnhover">
                            <i class="fa-solid fa-paperclip" style="color:#0a49b3;margin-right: 7px;margin-left: 3px;"></i>
                            <div style="display: inline;">Logo Files</div>
                          </router-link>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a @click="el_sure2(num)" class="preview_btnhover">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-replace-filled" width="22" height="22" viewBox="0 0 24 24" fill="#0949b3">
                               <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                               <path d="M8 2h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z" stroke-width="0" />
                               <path d="M20 14h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z" stroke-width="0" />
                               <path d="M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z" stroke-width="0" />
                               <path d="M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z" stroke-width="0" />
                             </svg>
                           </div>
                           <div style="display: inline;">Move to 'My Logos'</div>
                         </a>
                        </div>
                        <p v-if="sure2 && numerosure2 === num">Are you sure? <a @click="move_to_my_logos(num)" style="color:#5dba00;">YES</a> / <a @click="el_sure2(num)" style="color:#ee5150;">NO</a></p>
                        <div style="display:flex; margin-bottom:12px;">
                          <a @click="el_sure(num)" class="delete_btnhover">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#ee5150" version="1.1" xmlns="http://www.w3.org/2000/svg">
                               <path d="M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z" fill-rule="nonzero"></path>
                             </svg>
                           </div>
                           <div style="display: inline;">Delete</div>
                         </a>
                        </div>
                        <p v-if="sure && numerosure === num">Are you sure? <a @click="delete_draft(num)" style="color:#5dba00;">YES</a> / <a @click="el_sure(num)" style="color:#ee5150;">NO</a></p>
                        </div>
                        <div v-if="propsdata[0].paid !== 'yes' && logos.one_time_payment !== 'yes'" style="display: flex;">
                          <a :href="'/payment/sub/'+propsdata[0].unique_id+'?uil='+logos.unique_id+'&utm_campaign=dashboard_buy_logo'" class="btn btn-success w-100">
                            <svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC">
                              <path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path>
                            </svg> Download Logo
                          </a>
                        </div>
                        <div v-else style="display: flex;">
                          <router-link :to="'/dashboard/logo-files/'+logos.unique_id" class="btn btn-success w-100">
                            <svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC">
                              <path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path>
                            </svg> Download Logo
                          </router-link>
                        </div>
                     </div>
                   </div>
                </div>
                </div>
                </div>
                </div>
              </div>
            </div>
          </div>


<div v-if="(propsdata[0].logos === null || propsdata[0].logos.length === 0) && propsdata[0].logos_cargados" class="padding_dsp_de_1435">
  <div class="sc-hcnlBt kVTXUr" style="max-width: 1120px;margin: 0 auto;">
  <h2 class="sc-jRhVzh exltuq">Create Beautiful Logos</h2>
  <p class="sc-iHhHRJ iUpXMa">Our platform allows you to create, edit and download beautiful logos in just a few simple steps.</p>
  <a href="/create/" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255);display:initial!important;background-color: #ed1d62!important;"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
  Create Logos Now</a>
</div>
</div>

<!-- MODAL -->
<div v-if="propsdata[0].logos !== null && propsdata[0].logos_cargados" class="modal fade" id="modal-default" tabindex="-1" role="dialog" aria-labelledby="modal-default" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 850px;height: -webkit-fill-available;">
        <div class="modal-content modal-content-enmobile" style="height: -webkit-fill-available;">
            <div class="modal-header">
                <h6 class="modal-title">Logo Preview</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body document_preview" style="overflow: hidden auto; margin: 20px; padding: 0;">
              <div>
                <div class="d-flex justify-content-center" :style="'width: 100%; height: 404px; background: '+propsdata[0].logos[logo_preview]['background']+'; font-size: 25px; font-weight: 600; text-align: center; vertical-align: middle; line-height: 400px; color: rgb(255, 255, 255); border-radius: 0.5rem;'">
                  <div class="less_scale_preview_mobile drag_disabled" style="transform: scale(1);">
                    <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                      <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                        <img :src="'https://logo.app/svglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.svg?'+timenow" />
                      </div>
                      <div v-else>
                        <img :src="'https://svglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.svg?'+timenow" />
                      </div>
                    </div>
                    <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                      <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                        <img :src="'https://logo.app/paid-svglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.svg?'+timenow" />
                      </div>
                      <div v-else>
                        <img :src="'https://paid-svglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.svg?'+timenow" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4 para-ponerlos-en-el-medio">
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-9.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-9">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-2.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-2">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-13.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-13">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-14.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-14">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-10.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-10">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 para-que-no-se-achiquen-tanto">
                    <div class="d-flex justify-content-center" :style="'background: url(&quot;https://logo.app/create/mockups/mockup-4.png&quot;) center center / cover no-repeat, '+propsdata[0].logos[logo_preview]['background']+';width: 100%;height: 359px;position: relative;overflow: hidden;'">
                      <div>
                        <div class="dashboard-arrange-svg-inside-mockup-4">
                          <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview]['one_time_payment'] !== 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                          <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview]['one_time_payment'] === 'yes'">
                            <div v-if="propsdata[0].logos[logo_preview]['paid_svglogos_s3'] === 'needs_update'">
                              <img :src="'https://logo.app/paid-pnglogos/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                            <div v-else>
                              <img :src="'https://paid-pnglogos.s3.amazonaws.com/'+propsdata[0].logos[logo_preview]['unique_id']+'.png?'+timenow" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div role="alert" class="alert alert-secondary alert-dismissible fade show mb-0 classdefranco" style="border-radius: 0px;display: flex;justify-content: space-between;background-color: #1266c9;border-color: #1266c9;">
                <span class="alert-inner--text textoenmobilemodal" style="font-size: 18px; line-height: 42px;">This is just a preview of your logo. Download it now and get the svg & png format.</span>
                <a v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[logo_preview].one_time_payment === 'yes'" :href="'/svg-download/'+propsdata[0].logos[logo_preview].unique_id+'/'+propsdata[0].logos[logo_preview].titulo_specialchars_out" class="btn btn-white btn_del_continue">Download</a>
                <a v-else-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[logo_preview].one_time_payment !== 'yes'" :href="'/payment/sub/'+propsdata[0].unique_id+'?uil='+propsdata[0].logos[logo_preview].unique_id+'&utm_campaign=dashboard_preview_modal'" class="btn btn-white btn_del_continue">Download</a>
              </div>
            </div>
        </div>
    </div>
</div>

<!-- DUPLICATE MODAL -->
<div v-if="modal_duplicate" class="modal" style="display: block; padding-left: 0px; background-color: rgba(103, 103, 103, 0.26);">
    <div v-click-outside="hide_duplicate_modal" class="modal-dialog modal-dialog-centered" style="max-width: 850px;height: -webkit-fill-available;">
        <div class="modal-content modal-content-enmobile" style="max-height: -webkit-fill-available;">
            <div class="modal-header">
                <h5 class="modal-title">Duplicate Logo</h5>
                <button @click="hide_duplicate_modal" type="button" class="close">
                    <span v-if="!duplicating_logo" aria-hidden="true">&times;</span>
                    <span v-else class="spinner-border spinner-border-sm"></span>
                </button>
            </div>
            <div class="modal-body document_preview" style="overflow: hidden auto; margin: 20px; padding: 0;">
              <h3 class="text-center mb-3">Would you like to duplicate this logo?</h3>
              <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].logos[numeroduplicate]['one_time_payment'] !== 'yes'" class="text-center">
                <div v-if="propsdata[0].logos[numeroduplicate]['svglogos_s3'] === 'needs_update'">
                  <img :src="'https://logo.app/svglogos/'+propsdata[0].logos[numeroduplicate]['unique_id']+'.svg?'+timenow" style="width: 233px;border-radius: 5px;" />
                </div>
                <div v-else>
                  <img :src="'https://svglogos.s3.amazonaws.com/'+propsdata[0].logos[numeroduplicate]['unique_id']+'.svg?'+timenow" style="width: 233px;border-radius: 5px;" />
                </div>
              </div>
              <div v-if="propsdata[0].paid === 'yes' || propsdata[0].logos[numeroduplicate]['one_time_payment'] === 'yes'" class="text-center">
                <div v-if="propsdata[0].logos[numeroduplicate]['paid_svglogos_s3'] === 'needs_update'">
                  <img :src="'https://logo.app/paid-svglogos/'+propsdata[0].logos[numeroduplicate]['unique_id']+'.svg?'+timenow" style="width: 233px;border-radius: 5px;" />
                </div>
                <div v-else>
                  <img :src="'https://paid-svglogos.s3.amazonaws.com/'+propsdata[0].logos[numeroduplicate]['unique_id']+'.svg?'+timenow" style="width: 233px;border-radius: 5px;" />
                </div>
              </div>
              <div class="py-3 text-center">
                <div class="form-group">
                  <div class="d-sm-flex flex-column flex-sm-row mb-3 justify-content-center">
                    <button v-if="!duplicating_logo" @click="duplicate_logo" class="ml-sm-1 btn btn-success" style="min-width: 30%;">Yes, duplicate</button>
                    <button v-if="duplicating_logo" class="ml-sm-1 btn btn-success" style="min-width: 30%;">Duplicating <span class="spinner-border spinner-border-sm"></span></button>
                    <button v-if="!duplicating_logo" @click="hide_duplicate_modal" class="ml-sm-1 btn btn-danger" style="min-width: 30%;">No, don't duplicate</button>
                  </div>
                  <p v-if="duplicate_error" class="lead">There was an error, please try again.</p>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>

</div>

</template>

<style>
a {
  color: #515151;
}
.delete_btnhover:hover{
  color: #ee5150!important;
}
.preview_btnhover:hover{
  color: #073482!important;
}
.downloads_btnhover:hover{
  color: #073482!important;
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        timenow: Date.now(),
        sure: false,
        numerosure: '',
        sure2: false,
        numerosure2: '',
        edit: false,
        numeroedit: '',
        logo_preview: 0,
        modal_duplicate: false,
        numeroduplicate: '',
        duplicate_error: false,
        duplicating_logo: false,
        cargado: false
      };
    },
    methods: {
      el_sure(num){
        if(this.sure){
          this.sure = false;
        }
        else{
          this.sure = true;
        }
        this.numerosure = num;
      },
      delete_draft(num){
        axios.post('/dashboard/delete-draft.php', {
            unique_id: this.propsdata[0].logos[num].unique_id
          })
          this.propsdata[0].logos.splice(num, 1);
          if(this.propsdata[0].logos.length === 0){
            this.propsdata[0].logos = null;
          }
          this.sure = false;
          this.numerosure = '';
      },
      el_sure2(num){
        if(this.sure2){
          this.sure2 = false;
        }
        else{
          this.sure2 = true;
        }
        this.numerosure2 = num;
      },
      move_to_my_logos(num){
        axios.post('/dashboard/move-to-my-logos.php', {
            unique_id: this.propsdata[0].logos[num].unique_id
          })
          this.propsdata[0].logos.splice(num, 1);
          if(this.propsdata[0].logos.length === 0){
            this.propsdata[0].logos = null;
          }
          this.sure2 = false;
          this.numerosure2 = '';
      },
      lapicito(num){
        if(this.edit){
          this.edit = false;
        }
        else{
          this.edit = true;
        }
        this.numeroedit = num;
      },
      hide(){
        this.edit = false;
        if(this.propsdata[0].logos[this.numeroedit].titulo == ''){
          this.propsdata[0].logos[this.numeroedit].titulo = 'Untitled';
        }
        this.numeroedit = '';
      },
      edittitulo(num){
        axios.post('/dashboard/edit-titulo.php', {
            unique_id: this.propsdata[0].logos[num].unique_id,
            titulo: this.propsdata[0].logos[num].titulo
          })
      },
      logo_number(num){
        this.logo_preview = num;
      },
      show_duplicate_modal(num){
        this.modal_duplicate = true;
        this.numeroduplicate = num;
      },
      hide_duplicate_modal(){
        this.modal_duplicate = false;
        this.numeroduplicate = '';
      },
      duplicate_logo(){
        this.duplicate_error = false;
        this.duplicating_logo = true;
        axios.post('/dashboard/duplicate-logo.php', {
          unique_id: this.propsdata[0].logos[this.numeroduplicate].unique_id
        })
        .then(response => {
          if(response.data == 'try again'){
            this.duplicate_error = true;
            this.duplicating_logo = false;
          }
          else{
            //add the duplicated logo to the logos array
            this.propsdata[0].logos.unshift(response.data);
            this.modal_duplicate = false;
            this.duplicating_logo = false;
            // smooth scroll to the top of the page
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    mounted() {
      this.$emit('updatepath');
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/bookmarked-logos.vue